/* ===========================================================================
   DOMUS GIULIETTA: FORMULÁRIO DE AUTENTICAÇÃO (Bloco E, Tarefa 23)
   Carregado com defer por blocks/dg-form-autenticacao.liquid. Sem dependência e
   sem importar módulos do Horizon. Ouvintes em document: o editor re-renderiza o
   bloco sem recarregar a página.
   - Envio válido: o botão passa a dizer "Enviando…" (data-dg-enviando do
     contêiner), ganha aria-busy e ignora um segundo envio.
   - Página que volta do envio, com confirmação ou erro: o foco vai para a
     mensagem ([data-dg-form-retorno]).
   - Volta pelo histórico (bfcache): o botão recupera o texto original.
   A medição é do Bloco F (Tarefa 30), não daqui.
   =========================================================================== */
(function () {
  if (window.dgFormAut) return;

  function rotular(form, ocupado) {
    var raiz = form.closest('[data-dg-form-aut]');
    var botao = form.querySelector('button[type="submit"]');
    if (!raiz || !botao) return false;
    var texto = botao.querySelector('span') || botao;
    if (ocupado) {
      if (!botao.hasAttribute('data-dg-rotulo')) botao.setAttribute('data-dg-rotulo', texto.textContent);
      texto.textContent = raiz.getAttribute('data-dg-enviando') || texto.textContent;
      botao.setAttribute('aria-busy', 'true');
      return true;
    }
    if (botao.hasAttribute('data-dg-rotulo')) {
      texto.textContent = botao.getAttribute('data-dg-rotulo');
      botao.removeAttribute('data-dg-rotulo');
    }
    botao.removeAttribute('aria-busy');
    return true;
  }

  document.addEventListener('submit', function (evento) {
    var form = evento.target;
    if (!form || !form.closest || !form.closest('[data-dg-form-aut]')) return;
    var botao = form.querySelector('button[type="submit"]');
    if (botao && botao.getAttribute('aria-busy') === 'true') {
      evento.preventDefault();
      return;
    }
    rotular(form, true);
  });

  window.addEventListener('pageshow', function (evento) {
    if (!evento.persisted) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-dg-form-aut] form'), function (form) {
      rotular(form, false);
    });
  });

  function focarRetorno() {
    var retorno = document.querySelector('[data-dg-form-aut] [data-dg-form-retorno]');
    if (retorno) retorno.focus();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', focarRetorno);
  } else {
    focarRetorno();
  }

  window.dgFormAut = { rotular: rotular, focarRetorno: focarRetorno };
})();
